// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { safeLocalStorage } from "@/lib/safeStorage";

const SUPABASE_URL = "https://rkoaintvyaxvtfnnncul.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJrb2FpbnR2eWF4dnRmbm5uY3VsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NjkxNjYsImV4cCI6MjA2OTU0NTE2Nn0.3EP08Bc19RzDbHrJz2olRJ3ELAx7SBHDXxOa2PrbPDs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeLocalStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
